import React from 'react'
import { Radio } from 'antd'
import { observer } from 'mobx-react-lite'
import type { FieldMethods } from '../types'

const { Group } = Radio

export interface RadioGroupInputProps {
    field?: FieldMethods
    index?: number
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    [key: string]: any
}

export const RadioGroupInput: React.FC<RadioGroupInputProps> = observer(({ field, index }) => {
    if (!field) {
        return null
    }

    return <Group options={field.props?.options ?? []} {...field.bind({ index: index ?? 0 })} />
})
